export const clientRatingModal = 'clientRatingModal'
